import WiderLink from '@prismamedia/wider-link'

const pushDiaporama = [...document.querySelectorAll('.pushDiaporama')]

pushDiaporama.forEach((pushDiaporama) => {
	const widerLinkListItem = new WiderLink(pushDiaporama as HTMLElement)
	widerLinkListItem.init()
})
